import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { selectors, actions } from "rdx";
import { ProjectAlertTriangle } from "components/Icons";
import ConfirmModal from "components/mui-styled-components/Modals/ConfirmModal";
import { theme } from "styles/themes";
import * as S from "./styles";

type DuplicateLeadModalPropsT = {
  isModalOpen: boolean;
  handleCloseModal: () => void;
  onConfirm: () => void;
};

const modalHeader = (
  <S.HeaderContainer>
    <S.IconContainer>
      <ProjectAlertTriangle fill={theme.colors.pumpkin} width={20} height={20} />
    </S.IconContainer>
    Duplicate Lead Detected
  </S.HeaderContainer>
);

const DuplicateLeadModal = ({ isModalOpen, handleCloseModal, onConfirm }: DuplicateLeadModalPropsT) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { email = "", fullName = "", projectId = "" } = useSelector(selectors.selectDuplicateLeadDetails) || {};
  const canViewExisting = Boolean(projectId);

  const handleViewExisting = () => {
    if (!projectId) {
      return;
    }

    dispatch(actions.clearLeadToProposalDrawer());
    dispatch(actions.clearLatestMessage());
    dispatch(actions.setLeadToProposalDrawerVisible(false));
    dispatch(actions.setDuplicateLeadDetails({}));
    history.push(`/projects/${projectId}/summary`);
    handleCloseModal();
  };

  const handleClose = () => {
    handleCloseModal();
  };

  return (
    <ConfirmModal
      open={Boolean(isModalOpen && email && fullName)}
      cancelButton={canViewExisting}
      cancelButtonText="Cancel & View Existing"
      handleCancel={handleViewExisting}
      handleConfirm={onConfirm}
      handleClose={handleClose}
      maxWidth={500}
      title={modalHeader}
      titleStyles={{ paddingTop: "24px", paddingBottom: "16px" }}
      confirmButtonText="Proceed Anyway"
      justifyFooterContent="center"
      showCornerCloseButton
    >
      <S.ModalContentContainer>
        <div>A lead with similar information already exists in your system.</div>
        <S.ExistingLeadContainer>
          <div>Existing Lead:</div>
          <S.BoldText>{fullName}</S.BoldText>
          <S.BasicText>{email}</S.BasicText>
        </S.ExistingLeadContainer>
        <div>
          {canViewExisting
            ? "Would you like to proceed with creating a new lead entry, or would you prefer to view the existing one?"
            : "Would you like to proceed with creating a new lead entry?"}
        </div>
      </S.ModalContentContainer>
    </ConfirmModal>
  );
};

export default DuplicateLeadModal;
